export const HEADER_HEIGHT = '96px'
export const HEADER_TOP_PADDING = '31px'

export const SPACING_FROM_HEADER = '0px'

export const HOURS_TOGGLE_WIDTH = '47px'
export const HOURS_TOGGLE_HEIGHT = '18px'
export const MOBILE_FOOTER_HEIGHT = '71px'

export enum zIndex {
	BASE = 1,
	HEADER = 10,
	DIALOG_OVERLAY = 50,
	MOBILE_FOOTER = 51,
	DRAWER = 65,
	MARKET_DROPDOWN = 40,
}

export const STAKING_DISABLED = false

// This flag controls the one-click swap-deposit-trade feature
export const SWAP_DEPOSIT_TRADE_ENABLED = false
